import ViewSwitcher from '@anm/components/ViewSwitcher';
import { FC } from 'react';
import { compose } from 'recompose';
import styled from 'styled-components';

import withUser, { WithUserProps } from '../../../../HOCs/withUser';
import UpdateUserForm from '../../../user/UpdateUserForm';
import BackButton from '../../BackButton';
import SocialEmailButtonsBlock from '../../SocialEmailButtonsBlock';
import HaveAccountQuestion from '../../questions/HaveAccountQuestion';
import SignUpForm from '../SignUpForm';

import withSignUpStepsHandlers, {
  WithSignUpStepsHandlersProps
} from './HOCs/withSignUpStepsHandlers';

const SignUpWrapper = styled.div`
  min-height: 420px;
`;

type HOCs = WithSignUpStepsHandlersProps & WithUserProps;

const SignUpSteps: FC<HOCs> = ({
  auth,
  user,
  position: { current },
  handleSignUpEmailClick,
  handleEmailAuthSubmit,
  handleBackClick
}) => (
  <ViewSwitcher active={current}>
    <SocialEmailButtonsBlock
      onEmailButtonClick={handleSignUpEmailClick}
      renderQuestionBlock={() => <HaveAccountQuestion />}
    >
      Sign up
    </SocialEmailButtonsBlock>

    <SignUpWrapper>
      <SignUpForm
        onSubmit={handleEmailAuthSubmit}
        isPending={auth.isPending}
        submitError={auth.error && auth.error.message}
      >
        Create My Free Account
      </SignUpForm>

      <BackButton onClick={handleBackClick}>
        Sign up with a social account
      </BackButton>
    </SignUpWrapper>

    <UpdateUserForm isPending={user.isPending} validateOnBlur={false}>
      Save
    </UpdateUserForm>
  </ViewSwitcher>
);

export default compose<HOCs, {}>(
  withUser,
  withSignUpStepsHandlers
)(SignUpSteps);
